import { render, staticRenderFns } from "./WildCard.vue?vue&type=template&id=bd183954&scoped=true&"
import script from "./WildCard.vue?vue&type=script&lang=js&"
export * from "./WildCard.vue?vue&type=script&lang=js&"
import style0 from "./WildCard.vue?vue&type=style&index=0&id=bd183954&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd183954",
  null
  
)

component.options.__file = "WildCard.vue"
export default component.exports